import React from 'react';

class ShowQR extends React.Component {
	render() {
		return (
			<div>
				<div style={{ float: 'left', width: '100%', textAlign: 'center' }}>
					<div style={{ margin: '0 auto', width: '80%' }}>
						<img
                            style={{ width: '100%', display: 'block', borderRadius: '20px' }}
                            src={`data:image/png;base64, ${ this.props.parent.state.qr_image }`}
                            alt="QR"
                        />
					</div>
				</div>

				<div style={{ float: 'left', width: '100%', marginTop: '20px', textAlign: 'center' }}>
					<div onClick={ () => this.props.parent.setState({ page: 'home' }) } className="button pink2-invert auto-width">Tillbaka</div>
				</div>
			</div>
		)
	}
}
export default ShowQR;



// WEBPACK FOOTER //
// ./src/components/user/Dashboard/ShowQR.js